module.exports = __webpack_public_path__ + "static/media/image_58.2d3f6095.png";